import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'es',
    fullName: 'Spanish',
    nativeName: 'Español',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Algo sorprendente viene",
    landing_subtitle: "ArgVoid es un estudio de desarrollo de aplicaciones y juegos. ¡Estén atentos, pronto habrá novedades!",
    select_language: "Seleccionar idioma",
    search_placeholder: "Buscar idiomas...",
    terms_title: "Términos de servicio",
    policy_title: "política de privacidad",
    cookies_title: "Política de cookies",
    terms_content: `
        <strong>1. Aceptación de Términos</strong><br>
        Al acceder a ArgVoid, se aceptan estos Términos de servicio. Si no se aceptan estos términos, no se debe utilizar el servicio.<br><br>

        <strong>2. Uso de plataforma</strong><br>
        ArgVoid y sus aplicaciones se proporcionan "tal cual" con fines informativos y creativos. El servicio debe utilizarse únicamente para fines legales.<br><br>

        <strong>3. Conducta prohibida</strong><br>
        Está estrictamente prohibido explotar las vulnerabilidades del sitio, enviar spam o intentar acceder no autorizado a la infraestructura.<br><br>

        <strong>4. Descargo de responsabilidad</strong><br>
        La plataforma y los servicios podrán modificarse en cualquier momento sin previo aviso. No se proporciona ninguna garantía con respecto al tiempo de actividad o disponibilidad del servicio.
    `,
    policy_content: `
        <strong>1. Recopilación de información</strong><br>
        La plataforma no requiere autenticación de usuario ni creación de cuenta en este momento. No se recopila activamente información de identificación personal (como nombres o direcciones de correo electrónico) de los visitantes.<br><br>

        <strong>2. Datos de uso</strong><br>
        Se pueden recopilar análisis básicos y anónimos para comprender el tráfico del sitio y mejorar las aplicaciones. Estos datos no están vinculados a identidades de usuarios individuales.<br><br>

        <strong>3. Servicios de terceros</strong><br>
        Se pueden utilizar proveedores externos para servicios de alojamiento y análisis. Las prácticas de privacidad de estos respectivos proveedores rigen los datos anónimos procesados en su infraestructura.<br><br>

        <strong>4. Seguridad de datos</strong><br>
        Se implementan medidas de seguridad razonables para proteger la plataforma. Sin embargo, ningún método de transmisión a través de Internet es completamente seguro.<br><br>
    `,
    cookies_content: `
        <strong>1. ¿Qué son las cookies y el almacenamiento local?</strong><br>
        Las cookies y el almacenamiento local del navegador son pequeños archivos de datos que se almacenan en el dispositivo para recordar las preferencias de configuración durante las visitas.<br><br>

        <strong>2. Propósito de uso</strong><br>
        Browser LocalStorage se usa estrictamente para guardar ajustes de configuración, como:<br>
        - Preferencias de idioma<br>
        - Configuración de la interfaz de usuario (por ejemplo, configuración de diseño o tema) <br>
        - Caché de aplicación temporal<br><br>

        <strong>3. Sin seguimiento</strong><br>
        Las cookies y el almacenamiento local no se utilizan con fines publicitarios ni de seguimiento de terceros. Todos los datos almacenados son estrictamente para la funcionalidad principal de la plataforma.<br><br>

        <strong>4. Control</strong><br>
        Los datos del navegador se pueden borrar en cualquier momento a través de la configuración del navegador, lo que restablecerá cualquier configuración local.
    `,
    cookie_consent_text: "Utilizamos cookies básicas para garantizar que el sitio web funcione correctamente, como mantener su sesión activa, guardar su preferencia de idioma y otras configuraciones personalizadas.",
    read_policy: "Leer Política de Cookies",
    support_title: "Contactar con soporte",
    support_subject_label: "Sujeto",
    support_message_label: "Mensaje",
    support_submit_button: "Enviar mensaje",
    support_hint: "Nota: Esto abrirá su aplicación de correo electrónico predeterminada para enviar el mensaje.",
    support_success_msg: "Abriendo tu aplicación de correo electrónico...",
    support_error_msg: "No se pudo enviar el mensaje. Inténtelo de nuevo más tarde.",
    explorer_title: "Explorador",
    history_title: "Historia",
    animation_title: "Animación",
    config_title: "Configuración",
    tool_mouse: "Seleccione (Ctrl+M)",
    tool_brush: "Pincel (Ctrl+B)",
    tool_brush_mode: "Modo de alternancia (sólido/claro)",
    tool_eraser: "Borrador (Ctrl+E)",
    tool_brush_size: "Ajustar el tamaño del pincel",
    tool_bucket: "Rellenar (Ctrl+F)",
    tool_eyedropper: "Cuentagotas",
    tool_grid: "Cuadrícula (Ctrl+Mayús+B)",
    tool_rotate: "Girar (Ctrl+Mayús+R)",
    tool_flip_h: "Voltear H (Ctrl+Mayús+H)",
    tool_flip_v: "Voltear V (Ctrl+Mayús+V)",
    tool_transpose: "Transponer (Ctrl+Mayús+T)",
    label_width: "Ancho",
    label_height: "Altura",
    label_frames: "Número de cuadros",
    label_animation: "Estilo de animación",
    label_background_color: "Color de fondo",
    label_interval: "Intervalo",
    tool_anim_config: "Configuración de animación",
    label_new_width: "Nuevo ancho",
    label_new_height: "Nueva altura",
    label_apply: "Aplicar",
    label_colors: "Bandera",
    label_size: "Tamaño",
    label_tolerance: "Tolerancia",
    val_horizontal: "Horizontal",
    val_vertical: "Vertical",
    val_sequence: "Secuencia",
    val_bounce: "Rebotar",
    val_random: "Aleatorio",
    val_solid: "Sólido",
    val_clear: "Claro",
    action_add_sheet: "Nueva hoja",
    action_import: "Importar",
    action_export: "Exportar",
    action_sort_projects: "Clasificar",
    sort_date_old: "El más viejo primero",
    sort_date_new: "Lo más nuevo primero",
    sort_name_az: "Nombre (A-Z)",
    sort_name_za: "Nombre (Z-A)",
    action_new_sprite: "Nuevo objeto",
    action_new_project: "Nuevo proyecto",
    modal_save_all_title: "Guardar todos los cambios",
    modal_save_all_desc: "Seleccione los activos para guardar:",
    modal_save_selected: "Guardar Seleccionado",
    action_saved: "Guardado",
    modal_create_sprite_title: "Crear nuevo objeto",
    modal_create_project_title: "Crear nuevo proyecto",
    modal_add_sheet_title: "Agregar nueva hoja",
    modal_rename_sheet_title: "Cambiar nombre de hoja",
    modal_rename_sprite_title: "Cambiar nombre de objeto",
    modal_delete_sprite_title: "Eliminar objeto",
    modal_delete_project_title: "Eliminar proyecto",
    modal_delete_sheet_title: "Eliminar hoja",
    placeholder_sprite_name: "Nombre",
    placeholder_project_name: "Nombre",
    placeholder_sheet_name: "Nombre",
    placeholder_new_name: "Nuevo nombre",
    action_create: "Crear",
    action_add: "Agregar",
    action_rename: "Rebautizar",
    action_duplicate: "Duplicado",
    action_delete: "Borrar",
    action_cancel: "Cancelar",
    confirm_delete_sprite: "¿Estás seguro de que quieres eliminar este objeto?",
    confirm_delete_project: "¿Estás seguro de que deseas eliminar este proyecto? Todos los sprites serán eliminados.",
    confirm_delete_sheet: "¿Está seguro de que desea eliminar esta hoja?",
    err_select_sprite: "Primero seleccione un objeto.",
    err_select_project: "Primero seleccione un proyecto.",
    err_name_empty: "El nombre no puede estar vacío.",
    err_sprite_exists: "Ya existe un sprite con ese nombre.",
    err_project_exists: "Ya existe un proyecto con ese nombre.",
    err_no_content: "No hay contenido para guardar.",
    err_no_changes: "No hay cambios para guardar.",
    err_delete_last_sheet: "No se puede eliminar la última hoja.",
    err_extract_frames: "No se pudo extraer ningún fotograma.",
    err_indexeddb: "No se pudo guardar localmente. Es posible que su navegador no admita IndexedDB.",
    msg_upload_success: "Carga exitosa: {0}",
    msg_upload_failed: "Error de carga: {0}",
    msg_save_success: "Guardado exitoso.",
    msg_saving: "Ahorro...",
    msg_multi_save_result: "{0} activos guardados. {1} fallas.",
    menu_title: "Menú",
    menu_save: "Ahorrar",
    menu_save_all: "Guardar todo",
    menu_support: "Contactar con soporte",
    label_local_storage: "Almacenamiento local",
    label_sign_in: "Iniciar sesión",
    modal_export_title: "Exportar Sprite",
    label_filename: "Nombre del archivo",
    label_format: "Formato",
    action_export_confirm: "Exportar",
};

export default translations;
